import Vue from 'vue'

import {
  Button,
  Container,
  Aside,
  Main,
  Header,
  Footer,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  Link,
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Row,
  Col,
  Scrollbar,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Input,
  Form,
  FormItem,
  Message,
  Pagination,
  Loading,
  Dialog,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Tree,
  Radio,
  RadioButton,
  RadioGroup,
  Switch,
  Drawer,
  Tag,
  DatePicker,
  Select,
  Option,
  Steps,
  Step,
  Progress,
  Upload,
  CheckboxGroup,
  Checkbox,
  Popover,
  Calendar,
  Tooltip,
  Timeline,
  TimelineItem,
  InfiniteScroll,
  Cascader,
  Collapse,
  CollapseItem,
  Carousel,
  CarouselItem,
  InputNumber,
  Image,
  Autocomplete,
  Badge,
  // MessageBox,
  Divider,
  cascader,
  Rate
} from 'element-ui'

/* 全局设置 */
Vue.prototype.$ELEMENT = { size: 'mini', zIndex: 3000 }

Vue.use(Button)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(Rate)

/* 内容区组件 */
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Switch)
Vue.use(Divider)

Vue.use(Link)
Vue.use(Drawer)

Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(MenuItemGroup)

Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)

/* 布局组件 */
Vue.use(Container)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Header)
Vue.use(Footer)
Vue.use(Row)
Vue.use(Col)
Vue.use(Scrollbar)

Vue.use(Tree)
Vue.use(Tag)

Vue.use(Tabs)
Vue.use(TabPane)

Vue.use(Table)
Vue.use(TableColumn)

Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Option)

Vue.use(Pagination)
Vue.use(Loading)

Vue.use(Dialog)
Vue.use(cascader)
Vue.use(DatePicker)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Progress)
Vue.use(Upload)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Popover)
Vue.use(Calendar)
Vue.use(Tooltip)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Cascader)
Vue.use(InfiniteScroll)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Carousel)
Vue.use(InputNumber)
Vue.use(CarouselItem)
Vue.use(Image)
Vue.use(Autocomplete)
Vue.use(Badge)

// Vue.use(MessageBox)
Vue.prototype.$message = Message
